import {
  Contact,
  Users,
  CloudUpload,
  Share2,
  RefreshCw,
  Calendar,
  Settings,
  Package,
  SquareCheck,
  Search,
  BarChart3,
  Hand,
  Send,
  X,
  Truck,
  TriangleAlert,
} from "lucide-react";

export const HOME_TILES = [
  {
    id: "qoeSingleAddress",
    title: ["Quick Order Entry", "Single Address"],
    icon: Contact,
    to: "/quickOrderSelection",
    disabled: false,
    privilege: "qoeSingleAddress",
  },
  {
    id: "qoeMultipulAddresses",
    title: ["Quick Order Entry", "Multiple Address"],
    icon: Users,
    to: "/quickOrderMultipleAddress",
    disabled: true,
    privilege: "qoeMultipulAddresses",
  },
  {
    id: "bulkOrderUpload",
    title: "Bulk Order Upload",
    icon: CloudUpload,
    to: "/bulkOrderEntry",
    disabled: true,
    privilege: "bulkOrderUpload",
  },
  {
    id: "sampleRequest",
    title: "Sample Request",
    icon: Share2,
    to: "/sampleRequestOrder",
    disabled: true,
    privilege: "sampleRequest",
  },
  {
    id: "stockTransfer",
    title: "Stock Transfer",
    icon: RefreshCw,
    to: "/stockTransfer",
    disabled: false,
    privilege: "stockTransfer",
  },
  {
    id: "tradeShowprivileged",
    title: "Trade Show",
    icon: Calendar,
    to: "/tradeShowSelection",
    disabled: true,
    privilege: "tradeShowprivileged",
  },
  {
    id: "jacketDeduction",
    title: "Jacket Deduction",
    icon: Settings,
    to: "/jacket",
    disabled: false,
    privilege: "jacketDeduction",
  },
  {
    id: "miscellaneousOrdering",
    title: "Miscellaneous Orders",
    icon: RefreshCw,
    to: "/miscellaneousOrder",
    disabled: true,
    privilege: "miscellaneousOrdering",
  },
  {
    id: "shipTrack",
    title: "Ship Track",
    icon: Package,
    disabled: true,
    privilege: "shipTrack",
  },
  {
    id: "correctedRequesition",
    title: "Corrected Requesition",
    icon: SquareCheck,
    disabled: true,
    privilege: "correctedRequesition",
  },
  {
    id: "orderSearch",
    title: "Order Search",
    icon: Search,
    to: "/orderSearch",
    disabled: false,
    privilege: "orderSearch",
  },
  {
    id: "delinquentOrders",
    title: "Delinquent Orders",
    icon: BarChart3,
    to: "/delinquentOrderSearch",
    disabled: false,
    privilege: "delinquentOrders",
    badge: 0,
  },
  {
    id: "orderHoldRelease",
    title: "Order Hold Release",
    icon: Hand,
    to: "/holdOrderRelease",
    disabled: false,
    privilege: "orderHoldRelease",
    badge: 7,
  },
  {
    id: "backOrderRelease",
    title: "Release Back Orders",
    icon: Send,
    to: "/backOrderRelease",
    disabled: false,
    privilege: "backOrderRelease",
    badge: 0,
  },
  {
    id: "closeOrderRelease",
    title: "Close Orders",
    icon: X,
    disabled: true,
    privilege: "closeOrderRelease",
  },
  {
    id: "shippingModule",
    title: "Shipping Files",
    icon: Truck,
    to: "/shipFilesDashBoard",
    disabled: false,
    privilege: "shippingModule",
  },
  {
    id: "orderMonitor",
    title: "Order Monitor",
    icon: Search,
    to: "/orderMonitor",
    disabled: false,
    privilege: "orderMonitor",
  },
  {
    id: "errorMonitor",
    title: "Error Monitoring",
    icon: TriangleAlert,
    to: "/errorMonitor",
    disabled: false,
    privilege: "errorMonitor",
  },
  {
    id: "postageDataCollection",
    title: "Postage Data Collection",
    icon: Send,
    to: "/postageDataCollection",
    disabled: false,
    privilege: "postageDataCollection",
  },
  {
    id: "orderAddressManagement",
    title: "Order Address Management",
    icon: TriangleAlert,
    to: "/orderaddress",
    disabled: false,
    privilege: "orderAddressManagement",
  },
];
